import { render, staticRenderFns } from "./PopupVehicleInformationComment.vue?vue&type=template&id=5bef8263&scoped=true&lang=pug&"
import script from "./PopupVehicleInformationComment.vue?vue&type=script&lang=coffee&"
export * from "./PopupVehicleInformationComment.vue?vue&type=script&lang=coffee&"
import style0 from "./PopupVehicleInformationComment.vue?vue&type=style&index=0&id=5bef8263&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef8263",
  null
  
)

export default component.exports